module.exports = __webpack_public_path__ + "img/cx.104420a6.svg";